export const faqData = [
  {
    question: "canZayverseSupportMyBusiness",
    answer: "canZayverseSupportMyBusinessAnswer",
  },
  {
    question: "doesZayverseOfferBuiltInAdBlocker",
    answer: "doesZayverseOfferBuiltInAdBlockerAnswer",
  },
  {
    question: "howCanIManageMultipleClientAccounts",
    answer: "howCanIManageMultipleClientAccountsAnswer",
  },
  {
    question: "isZayverseSuitableForLowSpecDevices",
    answer: "isZayverseSuitableForLowSpecDevicesAnswer",
  },
  {
    question: "whatIsCurrentVersionOfZayaverse",
    answer: "whatIsCurrentVersionOfZayaverseAnswer",
  },
];

export const userData = [
  {
    id: 1,
    name: "johnDoe",
    email: "john@example.com",
    role: "admin",
  },
  {
    id: 2,
    name: "janeSmith",
    email: "jane@example.com",
    role: "user",
  },
];

export const gender = [
  { id: 1, name: "Male" },
  { id: 2, name: "Female" },
  { id: 3, name: "Prefer Not to Say" },
];

export const township = [
  { id: 1, name: "Kyauktada" },
  { id: 2, name: "Pabedan" },
  { id: 3, name: "Lanmadaw" },
  { id: 4, name: "Latha" },
  { id: 5, name: "Dagon" },
  { id: 6, name: "Botataung" },
  { id: 7, name: "Mingalar Taungnyunt" },
  { id: 8, name: "Pazundaung" },
  { id: 9, name: "Tamwe" },
  { id: 10, name: "Yankin" },
  { id: 11, name: "Thingangyun" },
  { id: 12, name: "Sanchaung" },
  { id: 13, name: "Kamayut" },
  { id: 14, name: "Bahan" },
  { id: 15, name: "Ahlon" },
  { id: 16, name: "Kyimyindaing" },
  { id: 17, name: "Mayangon" },
  { id: 18, name: "Hlaing" },
  { id: 19, name: "North Okkalapa" },
  { id: 20, name: "South Okkalapa" },
  { id: 21, name: "Insein" },
  { id: 22, name: "Mingaladon" },
  { id: 23, name: "Shwepyitha" },
  { id: 24, name: "Hlaingthaya" },
  { id: 25, name: "Dagon Seikkan" },
  { id: 26, name: "North Dagon" },
  { id: 27, name: "South Dagon" },
  { id: 28, name: "East Dagon" },
  { id: 29, name: "Dala" },
  { id: 30, name: "Seikkyi Kanaungto" },
  { id: 31, name: "Thaketa" },
  { id: 32, name: "Dawbon" },
  { id: 33, name: "Twante" },
  { id: 34, name: "Kungyangon" },
  { id: 35, name: "Kawhmu" },
  { id: 36, name: "Thanlyin" },
  { id: 37, name: "Kyauktan" },
  { id: 38, name: "Thongwa" },
  { id: 39, name: "Kayan" },
  { id: 40, name: "Hlegu" },
  { id: 41, name: "Hmawbi" },
  { id: 42, name: "Htantabin" },
  { id: 43, name: "Taikgyi" },
  { id: 44, name: "Cocokyun" },
];

export const nationality = [
  { id: 1, name: "Myanmar" },
  { id: 2, name: "Thailand" },
];

const mockData = {
  faqData,
  userData,
  gender,
  township,
  nationality,
};

export default mockData;
